import { render, staticRenderFns } from "./TopStats.vue?vue&type=template&id=48714605&"
import script from "./TopStats.vue?vue&type=script&lang=js&"
export * from "./TopStats.vue?vue&type=script&lang=js&"
import style0 from "./TopStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports